import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "my-3" }

import { keyBy } from "lodash";
import { computed, PropType, inject, ref } from "vue";

import { BusinessIdeaFieldCategoryMap, PersonFieldCategoryMap } from ".";
import providePersonFormInfo from "@/types/symbols/providePersonFormInfo";
import { DraftStartupperDto } from "@api/draft-startupper-dto";
import StartupperFormBasicFields from "./fields/StartupperFormBasicFields.vue";
import StartupperFormContactFields from "./fields/StartupperFormContactFields.vue";
import StartupperFormAdditionalFields from "./fields/StartupperFormAdditionalFields.vue";
import StartupperFormBusinessIdeaBasicFields from "./fields/StartupperFormBusinessIdeaBasicFields.vue";
import StartupperFormBusinessIdeaBackgroundFields from "./fields/StartupperFormBusinessIdeaBackgroundFields.vue";
import provideBusinessIdeaFieldCategoriesInfo from "@/types/symbols/provideBusinessIdeaFieldCategoriesInfo";


export default /*#__PURE__*/_defineComponent({
  __name: 'StartupperFormFields',
  props: {
	modelValue: {
		type: Object as PropType<DraftStartupperDto>,
		required: true,
	},
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const formDataComputed = computed({
	get() {
		return props.modelValue;
	},
	set(v) {
		emit("update:modelValue", v);
	},
});

const formInfo = inject(providePersonFormInfo);
const businessIdeaFieldCategories = inject(provideBusinessIdeaFieldCategoriesInfo);

const cats = computed(() => {
	return formInfo?.value?.fieldCategories || [];
});

const fieldsMap = computed(() => {
	return keyBy(cats.value, (r) => r.id) as unknown as PersonFieldCategoryMap;
});

const businessIdeaFieldsMap = computed(() => {
	return keyBy(
		businessIdeaFieldCategories?.value,
		(r) => r.id
	) as unknown as BusinessIdeaFieldCategoryMap;
});

const doNotAddBusinessIdea = ref<boolean>(false);

return (_ctx: any,_cache: any) => {
  const _component_HakoCheckbox = _resolveComponent("HakoCheckbox")!

  return (_openBlock(), _createElementBlock("div", null, [
    ((fieldsMap.value.StartupperBasicInfo?.fields ?? []).length > 0)
      ? (_openBlock(), _createBlock(StartupperFormBasicFields, {
          key: 0,
          modelValue: formDataComputed.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formDataComputed).value = $event)),
          fieldsMap: fieldsMap.value
        }, null, 8, ["modelValue", "fieldsMap"]))
      : _createCommentVNode("", true),
    ((fieldsMap.value.StartupperContactInfo?.fields ?? []).length > 0)
      ? (_openBlock(), _createBlock(StartupperFormContactFields, {
          key: 1,
          modelValue: formDataComputed.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formDataComputed).value = $event)),
          fieldsMap: fieldsMap.value
        }, null, 8, ["modelValue", "fieldsMap"]))
      : _createCommentVNode("", true),
    ((fieldsMap.value.StartupperAdditionalInfo?.fields ?? []).length > 0)
      ? (_openBlock(), _createBlock(StartupperFormAdditionalFields, {
          key: 2,
          modelValue: formDataComputed.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formDataComputed).value = $event)),
          fieldsMap: fieldsMap.value
        }, null, 8, ["modelValue", "fieldsMap"]))
      : _createCommentVNode("", true),
    ((businessIdeaFieldsMap.value.Basic?.fields ?? []).length > 0)
      ? (_openBlock(), _createBlock(StartupperFormBusinessIdeaBasicFields, {
          key: 3,
          modelValue: formDataComputed.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formDataComputed).value = $event)),
          fieldsMap: businessIdeaFieldsMap.value,
          noBusinessIdea: doNotAddBusinessIdea.value
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_HakoCheckbox, {
                modelValue: doNotAddBusinessIdea.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((doNotAddBusinessIdea).value = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("startupperForm.doNotAddBusinessIdea")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "fieldsMap", "noBusinessIdea"]))
      : _createCommentVNode("", true),
    (
				!doNotAddBusinessIdea.value && (businessIdeaFieldsMap.value.BackgroundInfo?.fields ?? []).length > 0
			)
      ? (_openBlock(), _createBlock(StartupperFormBusinessIdeaBackgroundFields, {
          key: 4,
          modelValue: formDataComputed.value,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formDataComputed).value = $event)),
          fieldsMap: businessIdeaFieldsMap.value
        }, null, 8, ["modelValue", "fieldsMap"]))
      : _createCommentVNode("", true)
  ]))
}
}

})